import type { MaybeRefOrGetter } from 'vue'
import { ref, toValue, watch } from 'vue'
import useApi from '../../components/js/Composables/useApi'
import type { UserLookupResult } from '../../Types/user'

export function useUserLookup(entityId: MaybeRefOrGetter<number | null>, email: MaybeRefOrGetter<string>) {
  const { getJSON } = useApi()

  const result = ref<UserLookupResult | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function lookup(): Promise<UserLookupResult | null> {
    const id = toValue(entityId)

    if (!id) {
      error.value = 'userLookup.errors.missingEntity'
      return null
    }

    loading.value = true
    error.value = null
    try {
      const params = new URLSearchParams({ email: toValue(email).trim(), entityId: String(id) })
      result.value = await getJSON(`users/lookup?${params.toString()}`)
      return result.value
    } catch (reason) {
      console.error(reason)
      result.value = null
      error.value = 'userLookup.errors.generic'
      return null
    } finally {
      loading.value = false
    }
  }

  function reset(): void {
    result.value = null
    error.value = null
  }

  watch([() => toValue(entityId), () => toValue(email)], reset)

  return {
    result,
    loading,
    error,
    lookup,
    reset,
  }
}
